<iframe
  #iframeElement
  [src]="effektivSrc()"
  sandbox="allow-same-origin"
  [title]="tittel()"
  [style.height]="effektivHoyde()"
  (load)="vedLasting()"
  data-testid="iframe-auto-hoyde"
></iframe>
